module.exports = __webpack_public_path__ + "e1a5b41145252ac92691644536a0f91d.svg";